module.exports = __webpack_public_path__ + "img/13.63b6a43e.svg";